import {
  Button,
  Box,
  styled,
  TextField,
  Typography,
  TypographyProps
} from '@mui/material';
import pallet from '../../../layouts/pallet';

const Wrapper = styled(Box)({
  position: 'relative',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: '100vh',
  padding: '16px',
  boxSizing: 'border-box'
});

const PositioningWrapper = styled(Box)({
  position: 'relative',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: '100%'
});

const Container = styled(Box)(({ theme }) => ({
  maxWidth: '450px',
  minWidth: '300px',
  borderRadius: '20px',
  backgroundColor: 'white',
  marginLeft: 'auto',
  marginRight: 'auto',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  position: 'relative',
  boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
  zIndex: 1,
  [theme.breakpoints.down('md')]: {
    width: '50%',
    minWidth: '400px'
  },
  [theme.breakpoints.down('sm')]: {
    width: '80%',
    minWidth: '320px'
  }
}));

const StyledHeader = styled(Typography)<TypographyProps>(({ theme }) => ({
  fontWeight: 600,
  fontSize: '1.3rem !important',
  marginTop: '30px',
  color: '#2B2A29',
  textAlign: 'left',
  [theme.breakpoints.down('sm')]: {
    fontSize: '1.1rem !important'
  }
}));

const StyledCenterAlignedHeader = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: '1.5rem !important',
  marginTop: '30px',
  color: '#2B2A29',
  textAlign: 'center',
  [theme.breakpoints.down('sm')]: {
    fontSize: '1.1rem !important'
  }
}));

const SubHeader = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: '1.1rem !important',
  marginTop: '20px',
  color: '#2B2A29',
  textAlign: 'left',
  [theme.breakpoints.down('sm')]: {
    fontSize: '1rem !important'
  }
}));

const StyledTextField = styled(TextField)(({ theme }) => ({
  width: '95%',
  marginTop: '10px',
  borderRadius: '8px',
  '& label.Mui-focused': {
    color: '#7A5AF8'
  },
  '& .MuiOutlinedInput-root': {
    '&.Mui-focused fieldset': {
      borderColor: '#7A5AF8'
    }
  },
  '& .MuiFormHelperText-root': {
    position: 'absolute',
    marginTop: '65px',
    fontSize: '0.7rem !important',
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.6rem !important'
    },
    [theme.breakpoints.up('md')]: {
      fontSize: '0.65rem !important'
    }
  }
}));

const SecondaryTitle = styled(Typography)({
  fontWeight: 600,
  fontSize: '0.9rem !important',
  color: '#2B2A29',
  marginTop: '40px'
});

const SubText = styled(Typography)(({ theme }) => ({
  fontSize: '0.9rem !important',
  lineHeight: '1.5 !important',
  marginTop: '8px',
  color: pallet.navigationItems,
  [theme.breakpoints.down('sm')]: {
    fontSize: '0.8rem !important'
  }
}));

const CenterAlignedSubText = styled(Typography)(({ theme }) => ({
  fontSize: '0.9rem !important',
  marginTop: '8px',
  color: pallet.navigationItems,
  [theme.breakpoints.down('sm')]: {
    fontSize: '0.8rem !important'
  },
  textAlign: 'center'
}));

const DisclaimerText = styled(Typography)(({ theme }) => ({
  textAlign: 'center',
  color: '#2B2A29',
  marginTop: '70px',
  marginBottom: 'revert',
  fontSize: '0.7rem !important',
  [theme.breakpoints.down('sm')]: {
    fontSize: '0.6rem !important'
  }
}));

const CustomStyledButton = styled(Button)(({ theme }) => ({
  borderRadius: '8px',
  marginTop: '10px',
  height: '50px',
  width: '95%',
  textTransform: 'none',
  [theme.breakpoints.down('sm')]: {
    height: '45px'
  }
}));

const LogoContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  width: '100%'
});

const StyledLogo = styled('img')({
  height: 45
});

const TopRightVector = styled('img')({
  position: 'absolute',
  top: '-70px',
  right: '-70px',
  width: '180px',
  zIndex: 0,
  pointerEvents: 'none'
});

const BottomLeftVector = styled('img')({
  position: 'absolute',
  bottom: '-70px',
  left: '-80px',
  width: '180px',
  zIndex: 0,
  pointerEvents: 'none'
});

const StyledEmail = styled('strong')({
  color: '#7A5AF8',
  fontWeight: 600
});

const HintText = styled(Typography)(({ theme }) => ({
  fontSize: '0.9rem !important',
  color: theme.palette.text.disabled,
  [theme.breakpoints.down('sm')]: {
    fontSize: '0.8rem !important'
  }
}));

const ErrorMessageContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  position: 'absolute',
  marginTop: '16px'
}));

const ErrorIconContainer = styled(Box)({
  paddingRight: '8px',
  paddingTop: '8px'
});

const ErrorMessageText = styled(Typography)(({ theme }) => ({
  color: theme.palette.error.main,
  fontVariant: 'caption',
  fontSize: '0.7rem !important',
  [theme.breakpoints.down('sm')]: {
    fontSize: '0.6rem !important'
  }
}));

export {
  Container,
  StyledHeader,
  SecondaryTitle,
  StyledTextField,
  SubHeader,
  SubText,
  DisclaimerText,
  CustomStyledButton,
  LogoContainer,
  StyledLogo,
  Wrapper,
  TopRightVector,
  BottomLeftVector,
  StyledEmail,
  HintText,
  PositioningWrapper,
  ErrorMessageContainer,
  ErrorIconContainer,
  ErrorMessageText,
  StyledCenterAlignedHeader,
  CenterAlignedSubText
};
